/**
 * DevExtreme (ui/widget/child_default_template.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var TemplateBase = require("./ui.template_base");
module.exports = TemplateBase.inherit({
    ctor: function(name) {
        this.name = name
    }
});



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/widget/child_default_template.js
// module id = ../../../../devextreme/ui/widget/child_default_template.js
// module chunks = common